export default __webpack_public_path__ + "static/media/avatar-s-12.09119fd6.jpg";